// グラフタイプごとのSVGアイコンコンポーネント

interface IconProps {
  size?: number;
  color?: string;
}

// ヒストグラムアイコン
export function HistogramIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect x="6" y="24" width="8" height="18" fill={color} opacity="0.8" />
      <rect x="16" y="14" width="8" height="28" fill={color} opacity="0.8" />
      <rect x="26" y="18" width="8" height="24" fill={color} opacity="0.8" />
      <rect x="36" y="28" width="8" height="14" fill={color} opacity="0.8" />
    </svg>
  );
}

// 散布図アイコン
export function ScatterPlotIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <circle cx="10" cy="32" r="3" fill={color} opacity="0.8" />
      <circle cx="15" cy="25" r="3" fill={color} opacity="0.8" />
      <circle cx="20" cy="28" r="3" fill={color} opacity="0.8" />
      <circle cx="25" cy="20" r="3" fill={color} opacity="0.8" />
      <circle cx="30" cy="15" r="3" fill={color} opacity="0.8" />
      <circle cx="35" cy="18" r="3" fill={color} opacity="0.8" />
      <circle cx="38" cy="12" r="3" fill={color} opacity="0.8" />
    </svg>
  );
}

// 棒グラフアイコン
export function BarChartIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect x="6" y="30" width="8" height="12" fill={color} opacity="0.8" />
      <rect x="16" y="18" width="8" height="24" fill={color} opacity="0.8" />
      <rect x="26" y="24" width="8" height="18" fill={color} opacity="0.8" />
      <rect x="36" y="12" width="8" height="30" fill={color} opacity="0.8" />
    </svg>
  );
}

// 時系列プロットアイコン
export function TimeSeriesIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <polyline
        points="6,35 12,30 18,28 24,20 30,22 36,15 42,18"
        stroke={color}
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.8"
      />
      <circle cx="6" cy="35" r="2" fill={color} opacity="0.8" />
      <circle cx="12" cy="30" r="2" fill={color} opacity="0.8" />
      <circle cx="18" cy="28" r="2" fill={color} opacity="0.8" />
      <circle cx="24" cy="20" r="2" fill={color} opacity="0.8" />
      <circle cx="30" cy="22" r="2" fill={color} opacity="0.8" />
      <circle cx="36" cy="15" r="2" fill={color} opacity="0.8" />
      <circle cx="42" cy="18" r="2" fill={color} opacity="0.8" />
    </svg>
  );
}

// 箱ひげ図アイコン
export function BoxPlotIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <line x1="12" y1="10" x2="12" y2="38" stroke={color} strokeWidth="2" opacity="0.6" />
      <rect x="8" y="18" width="8" height="14" fill={color} opacity="0.3" stroke={color} strokeWidth="1.5" />
      <line x1="8" y1="25" x2="16" y2="25" stroke={color} strokeWidth="2" opacity="0.8" />

      <line x1="24" y1="8" x2="24" y2="40" stroke={color} strokeWidth="2" opacity="0.6" />
      <rect x="20" y="15" width="8" height="16" fill={color} opacity="0.3" stroke={color} strokeWidth="1.5" />
      <line x1="20" y1="23" x2="28" y2="23" stroke={color} strokeWidth="2" opacity="0.8" />

      <line x1="36" y1="12" x2="36" y2="36" stroke={color} strokeWidth="2" opacity="0.6" />
      <rect x="32" y="20" width="8" height="12" fill={color} opacity="0.3" stroke={color} strokeWidth="1.5" />
      <line x1="32" y1="26" x2="40" y2="26" stroke={color} strokeWidth="2" opacity="0.8" />
    </svg>
  );
}

// ヒートマップアイコン
export function HeatmapIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      <rect x="6" y="6" width="10" height="10" fill={color} opacity="0.3" />
      <rect x="18" y="6" width="10" height="10" fill={color} opacity="0.5" />
      <rect x="30" y="6" width="10" height="10" fill={color} opacity="0.7" />
      <rect x="6" y="18" width="10" height="10" fill={color} opacity="0.6" />
      <rect x="18" y="18" width="10" height="10" fill={color} opacity="0.9" />
      <rect x="30" y="18" width="10" height="10" fill={color} opacity="0.4" />
      <rect x="6" y="30" width="10" height="10" fill={color} opacity="0.8" />
      <rect x="18" y="30" width="10" height="10" fill={color} opacity="0.5" />
      <rect x="30" y="30" width="10" height="10" fill={color} opacity="0.6" />
    </svg>
  );
}

// ペアプロットアイコン
export function PairPlotIcon({ size = 48, color = '#4285f4' }: IconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none">
      {/* 3x3グリッドの枠線 */}
      <rect x="4" y="4" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="17.5" y="4" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="31" y="4" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="4" y="17.5" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="17.5" y="17.5" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="31" y="17.5" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="4" y="31" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="17.5" y="31" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />
      <rect x="31" y="31" width="13" height="13" stroke={color} strokeWidth="0.5" fill="none" opacity="0.3" />

      {/* 対角線上のヒストグラム */}
      <g opacity="0.8">
        {/* 左上 */}
        <rect x="6" y="13" width="2" height="3" fill={color} />
        <rect x="9" y="10" width="2" height="6" fill={color} />
        <rect x="12" y="12" width="2" height="4" fill={color} />

        {/* 中央 */}
        <rect x="19.5" y="26.5" width="2" height="3" fill={color} />
        <rect x="22.5" y="23.5" width="2" height="6" fill={color} />
        <rect x="25.5" y="25.5" width="2" height="4" fill={color} />

        {/* 右下 */}
        <rect x="33" y="40" width="2" height="3" fill={color} />
        <rect x="36" y="37" width="2" height="6" fill={color} />
        <rect x="39" y="39" width="2" height="4" fill={color} />
      </g>

      {/* 非対角線上の散布図点 */}
      <g opacity="0.8">
        {/* 右上 (0,2) */}
        <circle cx="33" cy="8" r="1" fill={color} />
        <circle cx="36" cy="11" r="1" fill={color} />
        <circle cx="39" cy="13" r="1" fill={color} />

        {/* 中央上 (0,1) */}
        <circle cx="20" cy="8" r="1" fill={color} />
        <circle cx="23" cy="10" r="1" fill={color} />
        <circle cx="26" cy="13" r="1" fill={color} />

        {/* 中央右 (1,2) */}
        <circle cx="33" cy="21" r="1" fill={color} />
        <circle cx="36" cy="24" r="1" fill={color} />
        <circle cx="39" cy="26" r="1" fill={color} />

        {/* 左中央 (1,0) */}
        <circle cx="7" cy="21" r="1" fill={color} />
        <circle cx="10" cy="24" r="1" fill={color} />
        <circle cx="13" cy="26" r="1" fill={color} />

        {/* 左下 (2,0) */}
        <circle cx="7" cy="34" r="1" fill={color} />
        <circle cx="10" cy="37" r="1" fill={color} />
        <circle cx="13" cy="40" r="1" fill={color} />

        {/* 中央下 (2,1) */}
        <circle cx="20" cy="34" r="1" fill={color} />
        <circle cx="23" cy="37" r="1" fill={color} />
        <circle cx="26" cy="40" r="1" fill={color} />
      </g>
    </svg>
  );
}

// グラフタイプからアイコンコンポーネントを取得
export function getGraphTypeIcon(type: string, size?: number, color?: string) {
  const iconProps = { size, color };

  switch (type) {
    case 'histogram':
      return <HistogramIcon {...iconProps} />;
    case 'scatter':
      return <ScatterPlotIcon {...iconProps} />;
    case 'bar':
      return <BarChartIcon {...iconProps} />;
    case 'timeseries':
      return <TimeSeriesIcon {...iconProps} />;
    case 'boxplot':
      return <BoxPlotIcon {...iconProps} />;
    case 'heatmap':
      return <HeatmapIcon {...iconProps} />;
    case 'pairplot':
      return <PairPlotIcon {...iconProps} />;
    default:
      return <HistogramIcon {...iconProps} />;
  }
}
